import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

/**
 * Modal for adding/editing song comments
 * 
 * @param {boolean} show - Whether to show the modal
 * @param {function} onHide - Function to call when hiding the modal
 * @param {string} commentText - Current comment text
 * @param {function} setCommentText - Function to update comment text
 * @param {string} songTitle - Title of the song being commented on
 * @param {function} onSave - Function to call when saving the comment
 * @returns {JSX.Element} Modal component
 */
const CommentModal = ({ 
  show, 
  onHide, 
  commentText, 
  setCommentText, 
  songTitle, 
  onSave 
}) => (
  <Modal show={show} onHide={onHide} className="mobile-comment-modal">
    <Modal.Header closeButton className="bg-dark text-white border-secondary">
      <Modal.Title className="fs-6">
        {songTitle ? `Komentar za ${songTitle}` : 'Dodaj komentar'}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="bg-dark text-white">
      <Form.Group>
        <Form.Label>Komentar</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          placeholder="Dodaj opombe, napotke ali komentarje za to pesem..."
          className="bg-dark text-white border-secondary"
        />
      </Form.Group>
    </Modal.Body>
    <Modal.Footer className="bg-dark text-white border-secondary d-flex justify-content-center">
      <Button variant="outline-secondary" onClick={onHide} size="sm" className="mx-2">
        Prekliči
      </Button>
      <Button 
        variant="primary" 
        onClick={onSave}
        size="sm"
        className="mx-2"
      >
        Shrani komentar
      </Button>
    </Modal.Footer>
  </Modal>
);

export default CommentModal;